import React from 'react';
import TabRouting from '../../components/TabRouting';

const selectedMainTabIndex = 9;

const SummaryStatisticsMain = () => {
    return <TabRouting selectedMainTabIndex={selectedMainTabIndex}></TabRouting>;
};
export default SummaryStatisticsMain;
